import {Controller} from "react-hook-form";
import {Checkbox, ListItemText, MenuItem, TextField, TextFieldProps} from "@mui/material";
import {useTranslation} from "react-i18next";
import React from "react";

interface FormSelectFieldProps {
    name: string,
    control: any,
    disabled?: boolean,
    props: TextFieldProps,
    items: any[]
}

export const FormSelect = ({ name, control, disabled, props, items }: FormSelectFieldProps) => {

    const { t } = useTranslation('blackList');

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>
                <TextField {...props} {...field}
                           onChange={(e: any)=>{
                               props.onChange?.(e);
                               field.onChange(e);
                           }}
                           select
                           disabled={disabled}
                           error={!!error}
                           helperText={(error && error.type === 'required' && t('forms.required-field', { label: props.label })) || error?.message}
                >
                    {items}
                </TextField>
            }
        />
    );
}

export const renderMultiSelect = (label: string, list: any[], name: string, isHidden: boolean, onChange?: any) => {
    return (field: any, error: any, formState: any, watchAll: any, setValue: any) => (
        <TextField
            name={name}
            fullWidth
            select
            hidden={isHidden}
            disabled={list.length==0}
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) =>
                    selected
                        .map((s: any) => list.find((ss) => ss.value === s)!.label)
                        .join(", "),
            }}
            label={label}
            value={field.value}
            onChange={(event) => {
                if (onChange) {
                    onChange(event.target.value, setValue);
                }
                field.onChange(event);
            }}
            error={error !== undefined}
            helperText={error ? error.message : ""}
        >
            {list.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                    <Checkbox checked={field.value?.indexOf(item.value) > -1} />
                    <ListItemText primary={item.label} />
                </MenuItem>
            ))}
        </TextField>
    );
};
